module.exports = __webpack_public_path__ + "img/16581286_L.1463166d.png";